export default "__VITE_ASSET__CiC8CCf2__"